import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import debounce from 'lodash.debounce'
import FixFluidColGrid from '@/components/fix-fluid-col-grid/fix-fluid-col-grid.vue'
import ManufactureInfoItem from './components/manufacture-info-item/manufacture-info-item.vue'
import OrdersStatistics from '@/components/orders-statistics/orders-statistics.vue'
import TardinessStat from './components/tardiness-stat/tardiness-stat.vue'
import Loader from '@/components/loader/loader.vue'
import EditSettingsModal from '@/components/modals/edit-settings-modal/edit-settings-modal.vue'

export default {
  name: 'DashboardManufactures',
  components: {
    FixFluidColGrid,
    ManufactureInfoItem,
    OrdersStatistics,
    TardinessStat,
    Loader,
    EditSettingsModal
  },
  static() {
    return {
      expressIncluded: false,
      sortOptions: [
        {
          title: 'Сгоревшие',
          field: 'delivery_efficiency.delivery_expired_count'
        },
        {
          title: 'Дедлайн',
          field: 'delivery_efficiency.deadline_expired_count'
        },
        {
          title: 'Время ожидания курьера',
          field: 'delivery_efficiency.order_waiting_time'
        },
        {
          title: 'Заказы в работе',
          field: 'orders.in_work'
        }
      ]
    }
  },
  data() {
    return {
      manufacturesArr: [],
      tardinessInfo: {
        /**
         * "manufacture_id": 0,
         * "title": "Южное шоссе",
         * "all_count": 60,
         * "tardiness_count": 3,
         * "tardiness_percent": 5,
         * "is_critical": true
         */
        manufactures: [],
        total: {
          all_count: 0,
          tardiness_count: 0,
          tardiness_percent: 0
        }
      },
      selectedSortField: ''
    }
  },
  computed: {
    ...mapState({
      selectedCity: state => state.manufactures.selectedCity,
      selectedAreas: state => state.manufactures.selectedAreas,
      globalMinimized: state => state.dashboardManufactures.mininmized,
      manufacturesLoading: state => state.dashboardManufactures.manufacturesLoading,
      tardinessLoading: state => state.dashboardManufactures.tardinessLoading,
      pageLoading: state => state.pageLoader.loading
    }),
    ...mapGetters({
      settingsSchema: 'globalSettings/getSchema',
      settingsManufactures: 'globalSettings/getManufactures'
    }),
    sortedManufactures() {
      if (this.selectedSortField) {
        const sortFieldPath = this.selectedSortField.split('.')
        const res = [ ...this.manufacturesArr ]
          .sort((a, b) => {
            const aVal = a[sortFieldPath[0]][sortFieldPath[1]]
            const bVal = b[sortFieldPath[0]][sortFieldPath[1]]
            return bVal - aVal
          })
        return res
      }
      return this.manufacturesArr
    }
  },
  created() {
    this.selectedSortField = this.sortOptions[0].field
  },
  mounted() {
    this.$bus.$on('refresh-managers-info', this.refreshAllDataDebounce)
    if (this.selectedCity) {
      /**
       * !!! Не debounce
       */
      this.refreshAllData(true)
    }

    /**
     * иначе полагаемся на watch selectedCity
     */
    
  },
  beforeDestroy() {
    this.$bus.$off('refresh-managers-info', this.refreshAllDataDebounce)
  },
  methods: {
    ...mapActions({
      getManufactures: 'dashboardManufactures/getManufactures',
      cancelManufactures: 'dashboardManufactures/cancelManufactures',
      getTardiness: 'dashboardManufactures/getTardiness',
      cancelTardiness: 'dashboardManufactures/cancelTardiness',
      fetchSettings: 'globalSettings/fetchSettings',
      setSelectedManufactoryIds: 'globalSettings/setSelectedManufactoryIds',
      clearSettingsSelection: 'globalSettings/clearSelection',
      saveSettings: 'globalSettings/saveSettings'
    }),

    ...mapMutations({
      setMinimized: 'dashboardManufactures/SET_MINIMIZED'
    }),

    async refreshAllData(expressIncluded = false) {

      const cancelPromises = [
        this.cancelManufactures(),
        this.cancelTardiness()
      ]
      await Promise.all(cancelPromises)
      const dataPromises = [
        this.getManufactures().then(res => this.manufacturesArr = res.manufactures),
        this.getTardiness().then(res => this.tardinessInfo = res)
      ]
      if (expressIncluded) {
        dataPromises.push(this.$refs['orders-statistics'].refreshExpressAnalysis())
      }
      await Promise.all(dataPromises)
    },

    refreshAllDataDebounce: debounce(function(...args) {
      this.refreshAllData(...args)
    }, 500),    

    setSortField(selectedSortField) {
      this.selectedSortField = selectedSortField
    },

    async onOpenSettings(manufactureId) {
      await this.fetchSettings({ manufacture_ids: manufactureId })
      this.setSelectedManufactoryIds([manufactureId])
      this.$refs.editSettingsModal.show()
    },

    async onSettingsSave(payload) {
      try {
        await this.saveSettings(payload)
      } catch (error) {
        console.error('Failed to save settings:', error)
      }
    }
  },
  watch: {
    selectedCity() {
      /**
       * при выходе на стартовый экран город может обнулиться
       */
      if (this.selectedCity) {
        /**
         * Для того, чтобы не было повторного запроса в
         * watch selectedCity
         */
        this.expressIncluded = true
        this.refreshAllDataDebounce(true)
      }
    },
    selectedAreas() {
      if (this.expressIncluded) {
        this.expressIncluded = false
        return
      }
      /**
       * при выходе на стартовый экран город и производство могут обнулиться
       */
      if (this.selectedCity) {
        this.refreshAllDataDebounce(true)
      }
    }
  }
}